import React from "react";
import { useContext, useEffect, useState } from "react";
import "./home.scss";
import Sidebar from "../../../shared/components/sidebar/Sidebar";
import Navbar from "../../../shared/components/navbar/Navbar";
import ChartAdministradorNaoMedico from "../../../shared/components/chart/ChartAdministradorNaoMedico";
import { AuthContext } from "../../../shared/context/auth-context";
import { ClinicaContext } from "../../../shared/context/clinica-context";
import { useHttpClient } from "../../../shared/hooks/http-hook";
import DashboardIcon from "@mui/icons-material/Dashboard";

import Tasks from "../components/tasks/Tasks";
/* Substituiu o `Debitos`, que mostrava prestações fora de prazo. O componente
   antigo fica no sítio, sem ninguém a usá-lo, para se poder voltar atrás. */
import DividaExecutada from "../components/dividaExecutada/DividaExecutada";
import { useLoading } from "../../../shared/context/LoadingContext";

import "./HomeAdministradorNaoMedico.scss";
import "../../../shared/css/Checkbox.scss";
import CredenciaisExpirando from "../components/credenciaisExpirando/CredenciaisExpirando";

import StockAlerts from "../components/stockDashboard/StockAlerts";
import StockMovements from "../components/stockDashboard/StockMovements";

const DAILY_MESSAGES = [
  "Que o telefone toque só com boas notícias e pacientes simpáticos!",
  "Hoje o café é teu aliado e o sistema, teu campo de batalha!",
  "Organizar agenda é arte — e tu és o Picasso do Excel!",
  "Que o dia comece calmo e termine com tudo confirmado!",
  "Se o sistema travar, respira: nem o computador entende o stress da receção!",
  "Hoje é dia de transformar confusão em coordenação!",
  "Que tua paciência dure mais que fila de espera!",
  "O segredo do sucesso? Um sorriso na receção e um café por perto!",
  "Lembra: a primeira impressão do paciente é sempre o teu sorriso!",
  "Hoje a meta é simples: agendar tudo, perder nada e manter a calma!",
  "Que o Wi-Fi coopere e o paciente não esqueça o horário!",
  "Gerir clínica é fácil — disse ninguém nunca!",
  "Hoje o foco é brilhar: nos emails, nos atendimentos e no humor!",
  "Que cada ligação traga boas notícias e nenhum cancelamento!",
  "Organização é teu superpoder — e o caos, teu inimigo natural!",
  "Hoje és o maestro da clínica — e todos tocam conforme tua agenda!",
  "Que os lembretes cheguem antes dos atrasos!",
  "Nada é impossível quando há planilha, paciência e café!",
  "Hoje é o dia de mostrar que bom atendimento também cura!",
  "Que teu dia seja mais leve que a caixa de entrada!",
  "Se o plano de saúde complicar, sorri: é só mais uma terça-feira!",
  "Que tua gestão inspire e teu humor contagie!",
  "Hoje és o escudo contra o caos — e o caos respeita sorriso firme!",
  "Que o dia renda tanto quanto mês com feriado e bônus!",
  "Nada como começar o dia sabendo que sem ti, nada anda!",
  "Que tua voz no telefone soe tão doce quanto confirmação de consulta!",
  "Hoje o mundo pode girar, mas a receção não pode parar!",
  "Lembra: secretária boa não se estressa — sincroniza com o universo!",
  "Que teu dia seja tão eficiente quanto teu olhar quando alguém bagunça a agenda!",
  "Organizar pessoas é difícil, mas tu fazes parecer fácil!",
  "Hoje é dia de sorrir, resolver e brilhar — tudo ao mesmo tempo!",
  "Hoje lembra: o segredo da boa gestão é café quente e paciência gelada!",
];

function HomeAdministradorNaoMedico() {
  const { startLoading, stopLoading } = useLoading();
  const { sendRequest } = useHttpClient();
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);
  const [userData, setUserData] = useState();

  const [lucroAno, setLucroAno] = useState([]);
  ///////////////////

  console.log("clinica", clinica);
  console.log("auth", auth);
  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const [userResponse, lucroResponse] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/users/${auth.userId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/lucroano/${clinica.clinica._id}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
        ]);

        // Process user data
        setUserData({
          nome: userResponse.user.name,
          genero: userResponse.user.genero,
        });

        // Process lucro anual
        const meses = [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
        ];
        const lucroFormatted = meses.map((name, index) => ({
          name,
          lucro: lucroResponse.lucro[index] || 0,
        }));
        setLucroAno(lucroFormatted);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchData();
  }, [sendRequest, auth.userId, clinica.clinica._id, auth.token]);

  return (
    <>
      <div className="home">
        <Sidebar />
        <div className="homeContainer">
          <Navbar title="dashboard" icon={DashboardIcon} />
          <div className="dashboard__ola">
            <span className="dashboard__ola__big">{`Olá, ${auth.nomeAbreviado}!`}</span>
            <span className="dashboard__ola__small">
              {DAILY_MESSAGES[new Date().getDate() - 1] || ""}
            </span>
          </div>
          <div className="dashboard__top">
            {userData && lucroAno && (
              <ChartAdministradorNaoMedico
                nome={userData.nome}
                data={lucroAno}
              />
            )}

            <div className="caixa dashboard__right">
              <div className="dashboard__right__top__gerente">
                <CredenciaisExpirando
                  sendRequest={sendRequest}
                  auth={auth}
                  clinica={clinica}
                  estilo="dashboard__right__top__gerente__item"
                />

                <DividaExecutada
                  sendRequest={sendRequest}
                  auth={auth}
                  clinica={clinica}
                  estilo="dashboard__right__top__gerente__item"
                />
              </div>
              <hr />

              <div className="dashboard__right__bottom"></div>
            </div>
          </div>

          <div className="dashboard-assistente__stock__container">
            <StockAlerts
              clinicaId={clinica.clinica._id}
              sendRequest={sendRequest}
              auth={auth}
            />
            <StockMovements
              clinicaId={clinica.clinica._id}
              sendRequest={sendRequest}
              auth={auth}
              titulo="Minhas últimas movimentações"
            />
          </div>

          <div className="dashboard__bottom caixa tasks__container">
            <Tasks clinica={clinica} auth={auth} sendRequest={sendRequest} />
          </div>
        </div>
      </div>
    </>
  );
}

export default HomeAdministradorNaoMedico;
